import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=fe213bc0&scoped=true&"
import script from "./notify.vue?vue&type=script&lang=js&"
export * from "./notify.vue?vue&type=script&lang=js&"
import style0 from "./notify.vue?vue&type=style&index=0&id=fe213bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe213bc0",
  null
  
)

export default component.exports